export default {"src":"/_next/static/media/rocket.b923a6a2.svg","height":50,"width":45,"blurWidth":0,"blurHeight":0};